import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { focusLocationSearch } from '../../../../actions/locationActions';
import { brandSuggestedMenuSearch } from '../../../../actions/brandActions';
import BrandTopPicksComponent from '../../../../components/BrandTopPicks';
import scrollTo from '../../../../utils/scrollTo';

const LOCATION_SEARCH_ID = 'location-search-id';

class BrandTopPicks extends Component {
  componentDidMount() {
    const { brand } = this.props;
    this.props.brandSuggestedMenuSearch({ brand });
  }

  focusSearch = () => {
    if (typeof document !== 'undefined') {
      scrollTo(document.getElementById(LOCATION_SEARCH_ID), {
        duration: 400,
        padding: { top: 16 },
      }).then(this.props.focusLocationSearch); // TODO: change this behaviour to use shared state
    }
  };

  render() {
    const {
      suggestedMenuUrl,
      heading,
      description,
      viewMenuButtonLabel,
      findRestaurantButtonLabel,
      children,
    } = this.props;

    return (
      <BrandTopPicksComponent
        heading={heading}
        description={description}
        viewMenuButtonLabel={suggestedMenuUrl ? viewMenuButtonLabel : findRestaurantButtonLabel}
        onViewMenuButtonClick={suggestedMenuUrl ? undefined : this.focusSearch}
        menuLink={suggestedMenuUrl}
      >
        {children}
      </BrandTopPicksComponent>
    );
  }
}

BrandTopPicks.propTypes = {
  // Props from Redux
  brandSuggestedMenuSearch: PropTypes.func.isRequired,
  focusLocationSearch: PropTypes.func.isRequired,
  suggestedMenuUrl: PropTypes.string,

  // props from Storyblok
  brand: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  viewMenuButtonLabel: PropTypes.string.isRequired,
  findRestaurantButtonLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

BrandTopPicks.defaultProps = {
  suggestedMenuUrl: undefined,
};

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch) => ({
  brandSuggestedMenuSearch: (options) => dispatch(brandSuggestedMenuSearch(options)),
  focusLocationSearch: () => dispatch(focusLocationSearch()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BrandTopPicks);
